import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ContactUsDialogComponent } from '../contact-us-dialog/contact-us-dialog.component';

/**
 * The "Contact us" control the help carries.
 *
 * It opens a dialog rather than a bare `mailto:` link: a browser with no registered mail handler
 * does nothing at all with a `mailto:`, so the button read as dead. The dialog offers the mail app
 * and, for everyone else, the address itself.
 */
@Component({
  selector: 'app-contact-us-button',
  templateUrl: './contact-us-button.component.html',
  styleUrls: ['./contact-us-button.component.scss'],
  standalone: false,
})
export class ContactUsButtonComponent {
  constructor(private dialog: MatDialog) {}

  openContactUs(): void {
    this.dialog.open(ContactUsDialogComponent, {
      width: '480px',
      maxWidth: '95vw',
      autoFocus: false,
      panelClass: 'contact-us-dialog',
    });
  }
}
